import type { Config, Intent } from "./types";

interface ChatResponse {
  sessionId: string;
  response: string | null;
  intent: Intent;
  // isLive=true betyr at et menneske (Mattis/Elliot) har tatt over samtalen.
  // Da har serveren IKKE generert et AI-svar (response er null).
  isLive?: boolean;
  calendlyLink: string | null;
  mailDraft: string | null;
}

export async function sendMessage(
  cfg: Config,
  body: {
    sessionId: string | null;
    message: string;
    pageUrl: string;
    userAgent: string;
    referrer: string | null;
    customerName: string | null;
    customerEmail: string | null;
    gclid: string | null;
    gbraid: string | null;
    wbraid: string | null;
  }
): Promise<ChatResponse> {
  const res = await fetch(cfg.stokeApi, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function escalate(
  cfg: Config,
  body: { sessionId: string | null; name: string; email: string; message: string }
): Promise<{ ok: boolean; leadId: string }> {
  // Bytt fra direkte n8n-kall til Stoke API-proxy.
  // Stoke legger på Bearer-token server-side så det ikke eksponeres i frontend.
  const escalateUrl = cfg.stokeApi.replace(/\/?$/, "") + "/escalate";
  const res = await fetch(escalateUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export interface PollResponse {
  messages: { id: string; role: string; content: string; created_at: string }[];
  isLive: boolean;
  operator: string | null;
}

export async function pollMessages(
  cfg: Config,
  sessionId: string,
  after: string | null
): Promise<PollResponse> {
  const pollUrl = cfg.stokeApi.replace(/\/?$/, "") + "/poll";
  const params = new URLSearchParams({ sessionId });
  if (after) params.set("after", after);
  const res = await fetch(`${pollUrl}?${params}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function warmup(cfg: Config): Promise<void> {
  // Pre-warm Modal-containeren mens brukeren skriver navn/e-post.
  // Stoke-API'et er på samme origin som chat-endepunktet — utleder warmup-URL.
  const warmupUrl = cfg.stokeApi.replace(/\/?$/, "") + "/warmup";
  await fetch(warmupUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
}
